import { Apartment } from "components/ui/apartments-finishing/apartments-finishing";

export const apartmentsList = [
  {
    image: '/assets/images/apartments/23,85.png',
    title: 'Студия, 23,85 м²',
    price: 'от 6,2 млн руб',
    oldPrice: 'от 8,2 млн руб',
    commonSpace: '23,85 м²',
    livingSpace: '12,3 м²',
    dialogTitle: 'Студия',
    priceNumber: 6172380,
    oldPriceNumber: 8228250,
    firstText: 'Скидка 25%',
    secondText: 'Без отделки'
  },
  {
    image: '/assets/images/apartments/2с_53,67.png',
    title: '2-комнатная, 53,67 м²',
    price: 'от 12,3 млн руб',
    oldPrice: 'от 15,8 млн руб',
    commonSpace: '53,67 м²',
    livingSpace: '31,48 м²',
    dialogTitle: 'Двухкомнатная квартира',
    priceNumber: 12344100,
    oldPriceNumber: 15832650,
    firstText: 'Скидка 25%',
    secondText: 'Предчистовая отделка'
  },
  {
    image: '/assets/images/apartments/4с_46,91.png',
    title: '2-комнатная (евро), 46,91 м²',
    price: 'от 11,0 млн руб',
    oldPrice: 'от 14,1 млн руб',
    commonSpace: '46,91 м²',
    livingSpace: '27,66 м²',
    dialogTitle: 'Двухкомнатная квартира (евро)',
    priceNumber: 11000395,
    oldPriceNumber: 14119910,
    firstText: 'Скидка 25%',
    secondText: 'Предчистовая отделка'
  },
  {
    image: '/assets/images/apartments/26,08.png',
    title: 'Студия, 26,08 м²',
    price: 'от 7,6 млн руб',
    oldPrice: 'от 9,8 млн руб',
    commonSpace: '26,08 м²',
    livingSpace: '11,67 м²',
    dialogTitle: 'Студия',
    priceNumber: 7563200,
    oldPriceNumber: 9780000,
    firstText: 'Скидка 25%',
    secondText: 'Предчистовая отделка'
  },
  {
    image: '/assets/images/apartments/24,27.png',
    title: 'Студия, 24,27 м²',
    price: 'от 7,1 млн руб',
    oldPrice: 'от 9,2 млн руб',
    commonSpace: '24,27 м²',
    livingSpace: '11,93 м²',
    dialogTitle: 'Студия',
    priceNumber: 7130526,
    oldPriceNumber: 9222600,
    firstText: 'Скидка 25%',
    secondText: 'Предчистовая отделка'
  },
  {
    image: '/assets/images/apartments/25,57.png',
    title: 'Студия, 25,57 м²',
    price: 'от 7,4 млн руб',
    oldPrice: 'от 9,6 млн руб',
    commonSpace: '25,57 м²',
    livingSpace: '11,5 м²',
    dialogTitle: 'Студия',
    priceNumber: 7415300,
    oldPriceNumber: 9588750,
    firstText: 'Скидка 25%',
    secondText: 'Предчистовая отделка'
  },
  {
    image: '/assets/images/apartments/37,25.png',
    title: '1-комнатная, 37,25 м²',
    price: 'от 9,3 млн руб',
    oldPrice: 'от 12,0 млн руб',
    commonSpace: '37,25 м²',
    livingSpace: '16,65 м²',
    dialogTitle: 'Однокомнатная квартира',
    priceNumber: 9293875,
    oldPriceNumber: 11957250,
    firstText: 'Скидка 25%',
    secondText: 'Предчистовая отделка'
  },
  {
    image: '/assets/images/apartments/36,15.png',
    title: '1-комнатная, 36,15 м²',
    price: 'от 9,0 млн руб',
    oldPrice: 'от 11,6 млн руб',
    commonSpace: '36,15 м²',
    livingSpace: '17,92 м²',
    dialogTitle: 'Однокомнатная квартира',
    priceNumber: 9019425,
    oldPriceNumber: 11604150,
    firstText: 'Скидка 25%',
    secondText: 'Предчистовая отделка'
  },
  {
    image: '/assets/images/apartments/31,53.png',
    title: '1-комнатная, 31,53 м²',
    price: 'от 7,3 млн руб',
    oldPrice: 'от 9,8 млн руб',
    commonSpace: '31,53 м²',
    livingSpace: '12,2 м²',
    dialogTitle: 'Однокомнатная квартира',
    priceNumber: 7330725,
    oldPriceNumber: 9774300,
    firstText: 'Скидка 25%',
    secondText: 'Без отделки'
  },
  {
    image: '/assets/images/apartments/32,09.png',
    title: '1-комнатная, 32,09 м²',
    price: 'от 7,5 млн руб',
    oldPrice: 'от 9,9 млн руб',
    commonSpace: '32,09 м²',
    livingSpace: '13,25 м²',
    dialogTitle: 'Однокомнатная квартира',
    priceNumber: 7460925,
    oldPriceNumber: 9947900,
    firstText: 'Скидка 25%',
    secondText: 'Без отделки'
  },
  {
    image: '/assets/images/apartments/27,13.png',
    title: 'Студия, 27,13 м²',
    price: 'от 6,9 млн руб',
    oldPrice: 'от 9,2 млн руб',
    commonSpace: '27,13 м²',
    livingSpace: '12,82 м²',
    dialogTitle: 'Студия',
    priceNumber: 6918150,
    oldPriceNumber: 9224200,
    firstText: 'Скидка 25%',
    secondText: 'Без отделки'
  }
] satisfies Apartment[];

export const apartmentsFirstSecondList = [
  {
    image: "/assets/images/apartments/first-second/st/18-20.jpg",
    title: "Студия, 18,2 м²",
    price: "обновляем цены",
    oldPrice: "обновляем цены",
    commonSpace: "18,2 м²",
    livingSpace: "8,01 м²",
    dialogTitle: "Студия",
    firstText: "Скидка 30%",
    priceNumber: 4968600,
    oldPriceNumber: 7098000
  },
  {
    image: "/assets/images/apartments/first-second/st/19-73.jpg",
    title: "Студия, 19,73 м²",
    price: "обновляем цены",
    oldPrice: "обновляем цены",
    commonSpace: "19,73 м²",
    livingSpace: "8,01 м²",
    dialogTitle: "Студия",
    firstText: "Скидка 30%",
    priceNumber: 5013393,
    oldPriceNumber: 7161990
  },
  {
    image: "/assets/images/apartments/first-second/st/22-26.jpg",
    title: "Студия, 22,26 м²",
    price: "обновляем цены",
    oldPrice: "обновляем цены",
    commonSpace: "22,26 м²",
    livingSpace: "8,31 м²",
    dialogTitle: "Студия",
    firstText: "Скидка 30%",
    priceNumber: 5064150,
    oldPriceNumber: 7234500
  },

  {
    image: "/assets/images/apartments/first-second/1k/34-33.jpg",
    title: "1-комнатная, 34,33 м²",
    price: "обновляем цены",
    oldPrice: "обновляем цены",
    commonSpace: "34,33 м²",
    livingSpace: "11,9 м²",
    dialogTitle: "Однокомнатная квартира",
    firstText: "Скидка 30%",
    priceNumber: 6488370,
    oldPriceNumber: 9269100
  },
  {
    image: "/assets/images/apartments/first-second/1k/37-31.jpg",
    title: "1-комнатная, 37,31 м²",
    price: "обновляем цены",
    oldPrice: "обновляем цены",
    commonSpace: "37,31 м²",
    livingSpace: "16,73 м²",
    dialogTitle: "Однокомнатная квартира",
    firstText: "Скидка 30%",
    priceNumber: 6790420,
    oldPriceNumber: 9700600
  },
  {
    image: "/assets/images/apartments/first-second/1k/39-56.jpg",
    title: "1-комнатная, 39,56 м²",
    price: "обновляем цены",
    oldPrice: "обновляем цены",
    commonSpace: "39,56 м²",
    livingSpace: "16,34 м²",
    dialogTitle: "Однокомнатная квартира",
    firstText: "Скидка 30%",
    priceNumber: 6923000,
    oldPriceNumber: 9890000
  },
  {
    image: "/assets/images/apartments/first-second/1k/40-17.jpg",
    title: "1-комнатная, 40,17 м²",
    price: "обновляем цены",
    oldPrice: "обновляем цены",
    commonSpace: "40,17 м²",
    livingSpace: "15,52 м²",
    dialogTitle: "Однокомнатная квартира",
    firstText: "Скидка 30%",
    priceNumber: 7029750,
    oldPriceNumber: 10042500
  },

  {
    image: "/assets/images/apartments/first-second/2e/37-40.jpg",
    title: "2-комнатная (евро), 37,4 м²",
    price: "обновляем цены",
    oldPrice: "обновляем цены",
    commonSpace: "37,4 м²",
    livingSpace: "26,77 м²",
    dialogTitle: "Двухкомнатная квартира (евро)",
    firstText: "Скидка 30%",
    priceNumber: 6806800,
    oldPriceNumber: 9724000
  },
  {
    image: "/assets/images/apartments/first-second/2e/49-14.jpg",
    title: "2-комнатная (евро), 49,14 м²",
    price: "обновляем цены",
    oldPrice: "обновляем цены",
    commonSpace: "49,14 м²",
    livingSpace: "26,3 м²",
    dialogTitle: "Двухкомнатная квартира (евро)",
    firstText: "Скидка 30%",
    priceNumber: 8461908,
    oldPriceNumber: 12088440
  },
  {
    image: "/assets/images/apartments/first-second/2e/62-34.jpg",
    title: "2-комнатная (евро), 62,34 м²",
    price: "обновляем цены",
    oldPrice: "обновляем цены",
    commonSpace: "62,34 м²",
    livingSpace: "41,99 м²",
    dialogTitle: "Двухкомнатная квартира (евро)",
    firstText: "Скидка 30%",
    priceNumber: 10734948,
    oldPriceNumber: 15335640
  },
  {
    image: "/assets/images/apartments/first-second/2e/67-60.jpg",
    title: "2-комнатная (евро), 67,6 м²",
    price: "обновляем цены",
    oldPrice: "обновляем цены",
    commonSpace: "67,6 м²",
    livingSpace: "39,85 м²",
    dialogTitle: "Двухкомнатная квартира (евро)",
    firstText: "Скидка 30%",
    priceNumber: 11640720,
    oldPriceNumber: 16629600
  },

  {
    image: "/assets/images/apartments/first-second/3e/55-93.jpg",
    title: "3-комнатная (евро), 55,93 м²",
    price: "обновляем цены",
    oldPrice: "обновляем цены",
    commonSpace: "55,93 м²",
    livingSpace: "39,57 м²",
    dialogTitle: "Трёхкомнатная квартира (евро)",
    firstText: "Скидка 30%",
    priceNumber: 9631146,
    oldPriceNumber: 13758780
  },
  {
    image: "/assets/images/apartments/first-second/3e/61-37.jpg",
    title: "3-комнатная (евро), 61,37 м²",
    price: "обновляем цены",
    oldPrice: "обновляем цены",
    commonSpace: "61,37 м²",
    livingSpace: "42,97 м²",
    dialogTitle: "Трёхкомнатная квартира (евро)",
    firstText: "Скидка 30%",
    priceNumber: 10567914,
    oldPriceNumber: 15097020
  },
  {
    image: "/assets/images/apartments/first-second/3e/64-33.jpg",
    title: "3-комнатная (евро), 64,33 м²",
    price: "обновляем цены",
    oldPrice: "обновляем цены",
    commonSpace: "64,33 м²",
    livingSpace: "42,96 м²",
    dialogTitle: "Трёхкомнатная квартира (евро)",
    firstText: "Скидка 30%",
    priceNumber: 11077626,
    oldPriceNumber: 15825180
  },

  {
    image: "/assets/images/apartments/first-second/3k/74-58.jpg",
    title: "3-комнатная, 74,58 м²",
    price: "обновляем цены",
    oldPrice: "обновляем цены",
    commonSpace: "74,58 м²",
    livingSpace: "47,17 м²",
    dialogTitle: "Трёхкомнатная квартира",
    firstText: "Скидка 30%",
    priceNumber: 12842676,
    oldPriceNumber: 18346680
  },
  {
    image: "/assets/images/apartments/first-second/3k/77-54.jpg",
    title: "3-комнатная, 77,54 м²",
    price: "обновляем цены",
    oldPrice: "обновляем цены",
    commonSpace: "77,54 м²",
    livingSpace: "47,17 м²",
    dialogTitle: "Трёхкомнатная квартира",
    firstText: "Скидка 30%",
    priceNumber: 13352388,
    oldPriceNumber: 19074840
  },
  {
    image: "/assets/images/apartments/first-second/3k/78-06.jpg",
    title: "3-комнатная, 78,06 м²",
    price: "обновляем цены",
    oldPrice: "обновляем цены",
    commonSpace: "78,06 м²",
    livingSpace: "50,63 м²",
    dialogTitle: "Трёхкомнатная квартира",
    firstText: "Скидка 30%",
    priceNumber: 13441932,
    oldPriceNumber: 19202760
  },
  {
    image: "/assets/images/apartments/first-second/3k/83-32.jpg",
    title: "3-комнатная, 83,32 м²",
    price: "обновляем цены",
    oldPrice: "обновляем цены",
    commonSpace: "83,32 м²",
    livingSpace: "50,63 м²",
    dialogTitle: "Трёхкомнатная квартира",
    firstText: "Скидка 30%",
    priceNumber: 14347704,
    oldPriceNumber: 20496720
  }
] satisfies Apartment[];